import React from 'react';

import { NotificationsActive } from '@mui/icons-material';
import { ActionItemKeys, ContactName } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { BaseDashboardActionItem, PhoneVerificationModal } from '@uplift/ui-v2';

export type MobileVerificationActionItemProps = {
  contactId: string;
  contactName: ContactName;
  phone: string;
};

export const MobileVerificationActionItem: React.VFC<MobileVerificationActionItemProps> = ({ phone, contactId, contactName }) => {
  const l10n = useL10n();
  const [ verificationModalOpened, setVerificationModalOpened ] = React.useState(false);
  const currentUser = useCurrentuser();

  const handleSignUp = () => {
    trackToDoCTA({
      toDoType: ActionItemKeys.CLIENT_SMS_VERIFY,
      userType: UserRole.patient
    });
    setVerificationModalOpened(true);
  };

  return (
    <>
      <BaseDashboardActionItem
        title={l10n.dashboard.actionItems.mobilePhoneVerification.title}
        color="secondary"
        icon={<NotificationsActive />}
        action={{
          text: 'Sign up',
          handleClick: handleSignUp
        }}
      />
      {contactId && (
        <PhoneVerificationModal
          open={verificationModalOpened}
          onClose={() => setVerificationModalOpened(false)}
          userId={currentUser.id}
          phone={phone}
          contactId={contactId}
          contactName={contactName}
        />
      )}
    </>
  );
};

export const useMobileVerificationActionItem = () => {
  const clientSMS = useActionItem(ActionItemKeys.CLIENT_SMS_VERIFY);

  const actionItem = React.useMemo(() => {
    if (!clientSMS) {
      return null;
    }

    if (!clientSMS?.show) {
      return null;
    }

    return (
      <MobileVerificationActionItem
        contactId={clientSMS.contact?.contactId}
        contactName={clientSMS.contact?.contactName}
        phone={clientSMS.contact?.value}
      />
    );
  }, [ clientSMS ]);

  return {
    isLoading: clientSMS.isLoading,
    actionItem
  };
};

